// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3KxVI","selects":"Documents_selects__28DVO"};